define('ko_extended',["knockout"], function (ko) {
    "use strict";

    ko.bindingHandlers.domElement = {
        init: function (element, valueAccessor) {
            var observable = valueAccessor();
            if (ko.isObservable(observable)) {
                observable(element);
            }
        }
    };

    ko.bindingHandlers.toggleClick = {
        init: function (element, valueAccessor) {
            var observable = valueAccessor();
            ko.utils.registerEventHandler(element, "click", function () {
                observable(!observable());
            });
        }
    };

    ko.bindingHandlers.stopBinding = {
        init: function () {
            return { controlsDescendantBindings: true };
        }
    };

    ko.virtualElements.allowedBindings.stopBinding = true;

    return ko;
});
